import { Alert, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';

function MaterialNotifyComponent(props) {
    const [nameState, setNameState] = useState(props);

    useEffect(() => {
        setNameState(props);
    }, [props]);
    const handleClose = (e) => {
        props.onclose()
        setNameState({ ...nameState, open: false });
    }

    return (
        <Snackbar
            anchorOrigin={{
                vertical: "top",
                horizontal: "center"
            }}
            open={nameState.open}
            autoHideDuration={8000}
            onClose={handleClose}>
            <Alert onClose={handleClose} severity={nameState.severity} sx={{ width: '100%', fontFamily: "IRAN Sans" }}>
                {nameState.message}
            </Alert>
        </Snackbar>
    );
}

export default MaterialNotifyComponent;